import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMagnifyingGlass } from '@fortawesome/pro-regular-svg-icons/faMagnifyingGlass'
import {
    Spinner,
    MenuItem,
    Icon,
    Classes,
    Dialog,
    FormGroup,
    Button,
} from '@blueprintjs/core'

import { searchOwners } from 'src/store/modules/ui/runbook'
import {
    closeContactSearch,
    singleEditAction,
} from 'src/store/modules/ui/runbook/controls'
import {
    asyncUpdateRunbookSession,
    getRunbook,
    collectHiddenActionUids,
} from 'src/store/modules/runbooks'
import {
    getSelectedActions,
    updateAction,
} from 'src/store/modules/runbooks/actions'
import { openSupplier } from 'src/store/modules/cmdb/suppliers'
import ContactDialog from 'src/routes/Cmdb/Contacts/ContactDialog'
import InputSelect from './InputSelect'

class ContactSearcher extends React.Component {
    state = { supplierName: '' }

    componentDidMount() {
        this.contactSearch('')
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (
            prevProps.isChangingOwnerUserOnly !==
            this.props.isChangingOwnerUserOnly
        ) {
            this.contactSearch('')
        }
    }

    contactSearch = (query) => {
        const { actions } = this.props

        actions.searchOwners(query)
    }

    contactInputRef = (ref) => (this.contactInput = ref)

    contactSearchRenderer = (item, { handleClick, modifiers }) => (
        <MenuItem
            active={modifiers.active}
            key={item.id}
            label={item.contactType}
            onClick={handleClick}
            text={item.label}
        />
    )

    handleAddNewContact = (e) => {
        const { actions } = this.props

        this.setState(
            { supplierName: e.target.textContent.substring(4) },
            () => {
                actions.openSupplier()
            }
        )
    }

    handleContactSelect = ({ contactType, id, label }) => {
        const {
            selectedActions,
            runbookId,
            isChangingOwnerUserOnly,
            actions: { asyncUpdateAction, updateAction, closeContactSearch },
            isEditing,
            runbook,
        } = this.props

        const newLabel = contactType === 'user' ? label.split(' - ')[0] : label

        if (runbookId && !isEditing) {
            asyncUpdateAction(
                selectedActions,
                {
                    action: 'transfer',
                    contactType,
                    label: newLabel,
                    propagate: false,
                    id,
                },
                runbook
            )
            closeContactSearch()
            return
        }
        if (contactType === 'supplier') {
            selectedActions.forEach((uid) =>
                updateAction(uid, {
                    ownerSupplier: label,
                    ownerTeam: null,
                    ownerUser: null,
                    ownerSupplierId: id,
                    ownerTeamId: null,
                    ownerUserId: null,
                    selected: false,
                })
            )
            closeContactSearch()
            return
        }
        if (contactType === 'team') {
            selectedActions.forEach((uid) =>
                updateAction(uid, {
                    ownerSupplier: null,
                    ownerTeam: label,
                    ownerUser: null,
                    ownerSupplierId: null,
                    ownerTeamId: id,
                    ownerUserId: null,
                    selected: false,
                })
            )
            closeContactSearch()
            return
        }
        selectedActions.forEach((uid) =>
            updateAction(
                uid,
                isChangingOwnerUserOnly
                    ? {
                          ownerUser: newLabel,
                          ownerUserId: id,
                          selected: false,
                      }
                    : {
                          ownerSupplier: null,
                          ownerTeam: null,
                          ownerUser: newLabel,
                          ownerSupplierId: null,
                          ownerTeamId: null,
                          ownerUserId: id,
                          selected: false,
                      }
            )
        )
        closeContactSearch()
    }

    handleContactClose = () => {
        this.props.actions.closeContactSearch()
    }

    render() {
        const { supplierName } = this.state
        const {
            contactOptions,
            contactsLoading,
            isChangingOwner,
            addingNewSupplier,
            selectedActions,
            runbook,
        } = this.props

        let owner = null
        let ownerTeam = null
        if (selectedActions.length === 1) {
            const selectedActionId = selectedActions[0]
            const selectedAction = runbook.actions.byId[selectedActionId]
            owner = selectedAction.ownerUser
            ownerTeam = selectedAction.ownerTeam
        }

        return (
            isChangingOwner && (
                <React.Fragment>
                    {addingNewSupplier && (
                        <ContactDialog name={this.state.supplierName} />
                    )}
                    <Dialog
                        isOpen={true}
                        onClose={this.handleContactClose}
                        title="Add owner"
                    >
                        <div className={Classes.DIALOG_BODY}>
                            <FormGroup
                                label="Resolver group"
                                labelFor="resolver-group"
                            >
                                <InputSelect
                                    inputProps={{
                                        id: 'resolver-group',
                                        large: true,
                                        inputRef: this.contactInputRef,
                                        rightElement: contactsLoading ? (
                                            <Spinner
                                                size={Icon.SIZE_STANDARD}
                                            />
                                        ) : null,
                                        leftElement: (
                                            <FontAwesomeIcon
                                                icon={faMagnifyingGlass}
                                            />
                                        ),
                                    }}
                                    openOnKeyDown={false}
                                    onQueryChange={this.contactSearch}
                                    selectedItem={{
                                        name: supplierName || ownerTeam,
                                    }}
                                    items={contactOptions.filter((contact) => {
                                        return contact.contactType === 'team'
                                    })}
                                    itemRenderer={this.contactSearchRenderer}
                                    inputValueRenderer={(supplier) =>
                                        supplier.name
                                    }
                                    noResults={
                                        <MenuItem
                                            onClick={this.handleAddNewContact}
                                            text={`Add ${
                                                this.contactInput
                                                    ? this.contactInput.value
                                                    : ''
                                            }`}
                                        />
                                    }
                                    onItemSelect={this.handleContactSelect}
                                    popoverProps={{
                                        minimal: true,
                                        targetClassName: 'full-width',
                                    }}
                                    minimal={true}
                                />
                            </FormGroup>
                            <FormGroup label="Assignee" labelFor="assignee">
                                <InputSelect
                                    inputProps={{
                                        id: 'assignee',
                                        large: true,
                                        inputRef: this.contactInputRef,
                                        rightElement: contactsLoading ? (
                                            <Spinner
                                                size={Icon.SIZE_STANDARD}
                                            />
                                        ) : null,
                                        leftElement: (
                                            <FontAwesomeIcon
                                                icon={faMagnifyingGlass}
                                            />
                                        ),
                                    }}
                                    openOnKeyDown={false}
                                    onQueryChange={this.contactSearch}
                                    selectedItem={{
                                        name: supplierName || owner,
                                    }}
                                    items={contactOptions.filter((contact) => {
                                        return contact.contactType === 'user'
                                    })}
                                    itemRenderer={this.contactSearchRenderer}
                                    inputValueRenderer={(supplier) =>
                                        supplier.name
                                    }
                                    noResults={
                                        <MenuItem
                                            onClick={this.handleAddNewContact}
                                            text={`Add ${
                                                this.contactInput
                                                    ? this.contactInput.value
                                                    : ''
                                            }`}
                                        />
                                    }
                                    onItemSelect={this.handleContactSelect}
                                    popoverProps={{
                                        minimal: true,
                                        targetClassName: 'full-width',
                                    }}
                                    minimal={true}
                                />
                            </FormGroup>
                        </div>
                        <div className={Classes.DIALOG_FOOTER}>
                            <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                                <Button
                                    intent="primary"
                                    large
                                    onClick={() => {}}
                                >
                                    Save
                                </Button>
                                <Button
                                    intent="lynch-underline"
                                    large
                                    onClick={this.handleContactClose}
                                >
                                    Cancel
                                </Button>
                            </div>
                        </div>
                    </Dialog>
                </React.Fragment>
            )
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    const {
        contactsLoading,
        contactOptions,
        controls: {
            isChangingOwner,
            singleOpenAction,
            isChangingOwnerUserOnly,
        },
    } = state.ui.runbook
    const selectedActions = getSelectedActions(state, ownProps.runbookId)
    const runbook = getRunbook(state, ownProps.runbookId)
    const { isEditing } = runbook
    return {
        runbook,
        isEditing,
        contactOptions,
        contactsLoading,
        isChangingOwner,
        isChangingOwnerUserOnly,
        selectedActions: singleOpenAction
            ? [singleOpenAction]
            : selectedActions,
        addingNewSupplier: state.cmdb.suppliers.modalOpen,
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        dispatch,
        actions: bindActionCreators(
            {
                searchOwners,
                closeContactSearch,
                singleEditAction,
                openSupplier,
                asyncUpdateAction: (actionUids, data, runbookState) => {
                    // Collect hidden action UIDs if runbook state is provided
                    const hiddenActionUids = runbookState
                        ? collectHiddenActionUids(runbookState.actions?.byId)
                        : []

                    return asyncUpdateRunbookSession(
                        ownProps.runbookId,
                        actionUids,
                        data,
                        hiddenActionUids
                    )
                },
                updateAction: (actionUid, data) =>
                    updateAction(ownProps.runbookId, actionUid, data),
            },
            dispatch
        ),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ContactSearcher)
